import { useEffect, useState } from "react";
import { Trophy, Medal } from "lucide-react";
import api from "@/lib/api";
import { Layout } from "@/components/Layout";

const ZONES = [
  { id: "casual", name: "New Jack" },
  { id: "golden_era", name: "Triple OG"},
  
];

export default function Leaderboard() {
  const [zone, setZone] = useState("casual");
  const [scope, setScope] = useState("daily");
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/game/leaderboard/${zone}?scope=${scope}`).then(({ data }) => setRows(data.entries)).finally(() => setLoading(false));
  }, [zone, scope]);

  return (
    <Layout>
      <div className="max-w-4xl mx-auto px-5 sm:px-8 py-14">
        <p className="font-mono-caps text-xs text-primary mb-3">Rankings</p>
        <h1 className="font-display text-5xl mb-8 flex items-center gap-3"><Trophy className="text-primary" size={40} /> LEADERBOARDS</h1>

        <div className="flex flex-wrap gap-2 mb-4">
          {ZONES.map((z) => (
            <button key={z.id} onClick={() => { setZone(z.id); setScope("daily"); }}
              className={`font-mono-caps text-[10px] px-4 py-2.5 border transition-colors ${zone === z.id ? "bg-primary text-primary-foreground border-primary" : "border-white/20 text-muted-foreground hover:border-primary"}`}>
              {z.name}
            </button>
          ))}
        </div>
        <div className="flex gap-2 mb-8">
          {["overall"].map((s) => (
<button key={s} onClick={() => { setZone("overall"); setScope("overall"); }} data-testid={`lb-scope-${s}`} 
             className={`font-mono-caps text-[10px] px-4 py-2 border transition-colors ${scope === s ? "bg-primary text-primary-foreground border-primary" : "border-white/20 text-muted-foreground hover:border-primary"}`}>
              {s}
            </button>
          ))}
        </div>

        <div className="border border-white/15 bg-card" data-testid="leaderboard-table">
          <div className="grid grid-cols-12 font-mono-caps text-[9px] text-muted-foreground px-5 py-3 border-b border-white/10">
            <span className="col-span-2">Rank</span><span className="col-span-7">Player</span><span className="col-span-3 text-right">Score</span>
          </div>
          {loading ? (
            <div className="px-5 py-10 text-center font-mono-caps text-[10px] text-muted-foreground animate-pulse">Loading…</div>
          ) : rows.length === 0 ? (
            <div className="px-5 py-12 text-center text-muted-foreground text-sm">No scores yet. Be the first to drop a score!</div>
          ) : (
            rows.map((r) => (
              <div key={r.rank} className={`grid grid-cols-12 items-center px-5 py-3.5 border-b border-white/5 ${r.is_me ? "bg-primary/10" : ""}`} data-testid={`lb-row-${r.rank}`}>
                <span className="col-span-2 font-display text-xl flex items-center gap-1">
                  {r.rank <= 3 ? <Medal size={16} className={r.rank === 1 ? "text-primary" : r.rank === 2 ? "text-zinc-300" : "text-amber-700"} /> : null}{r.rank}
                </span>
                <span className="col-span-7 text-sm truncate">{r.user_name}{r.is_me && <span className="text-primary font-mono-caps text-[9px] ml-2">You</span>}</span>
                <span className="col-span-3 text-right font-display text-xl text-primary">{r.score}</span>
              </div>
            ))
          )}
        </div>
      </div>
    </Layout>
  );
}
